import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: {
  display: "block"
}, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 3.75V14.25", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3.75 9H14.25", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
